import { NgIf, AsyncPipe } from '@angular/common'
import { Component, HostListener, Inject, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'
import { TranslatePipe, WindowRef } from '@spartacus/core'
import { PageSlotComponent } from '@spartacus/storefront'
import { CookieService } from 'ngx-cookie-service'
import { BehaviorSubject, Observable, Subscription } from 'rxjs'
import { take } from 'rxjs/operators'
import { EbCsagentAuthService } from '../../../asm/services/eb-csagent-auth.service'
import { EbAuthStatePersistenceService } from '../../../auth/services/eb-auth-state-persistence.service'
import { EbAuthService } from '../../../auth/services/eb-auth.service'
import { EbUserIdService } from '../../../auth/services/eb-user-id.service'
import { EbUserAccountService } from '../../services/eb-user-account.service'

@Component({
  selector: 'eb-login',
  templateUrl: './eb-login.component.html',
  styleUrls: ['./eb-login.component.scss'],
  standalone: true,
  imports: [NgIf, PageSlotComponent, AsyncPipe, TranslatePipe]
})
export class EbLoginComponent implements OnDestroy {
  isLoggedIn$: Observable<boolean> = this.authService.isUserLoggedIn()
  private readonly mode$ = new BehaviorSubject<string>(null)
  private readonly subscriptions = new Subscription()

  constructor(
    public userAccountService: EbUserAccountService,
    protected authService: EbAuthService,
    protected router: Router,
    protected userIdService: EbUserIdService,
    @Inject(EbAuthStatePersistenceService)
    protected ebAuthStatePersistenceService: EbAuthStatePersistenceService,
    protected csAgentAuthService: EbCsagentAuthService,
    protected cookieService: CookieService,
    protected winRef: WindowRef
  ) {}

  @HostListener('click', ['$event'])
  handleAccountLinkClick(event: MouseEvent): void {
    const anchor = (event.target as HTMLElement | null)?.closest('a')
    if (!anchor || !this.isSamlLogoutUrl(anchor.href)) {
      return
    }

    this.userIdService
      .isEmulated()
      .pipe(take(1))
      .subscribe(isEmulated => {
        if (!this.isAsmCustomerEmulationActive(isEmulated)) {
          return
        }

        event.preventDefault()
        event.stopPropagation()
        void this.csAgentAuthService.stopCustomerImpersonation()
      })
  }

  loginWithSapIDP() {
    this.authService.loginWithSapIDP()
  }

  reportRenderMode(mode: string) {
    this.mode$.next(mode)
    return mode
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }

  private isSamlLogoutUrl(url: string): boolean {
    return url.includes('/samlsinglesignon/saml/logout')
  }

  private isAsmCustomerEmulationActive(isEmulated: boolean): boolean {
    const hasEmulatedCustomerToken = Boolean(
      this.winRef.localStorage?.getItem('emulatedUserToken') ||
      this.cookieService.get('temp_customer_emulation_token')
    )

    return Boolean(this.cookieService.get('asAgent') && (isEmulated || hasEmulatedCustomerToken))
  }
}
